<template>
  <main class="promoter-login">
    <van-nav-bar
      title="推广员登录"
      fixed
      placeholder
      safe-area-inset-top
    />
    <section class="login-content">
      <h1>欢迎访问</h1>
      <van-form :show-error="false" @submit="onSubmit">
        <h2>请登录</h2>
      <van-field
        v-model.trim="mobile" type="tel" name="mobile" placeholder="手机号"
        autocomplete="tel" maxlength="11" :disabled="submitting || sending"
        :rules="[{ validator: validMobile, message: '请输入正确的11位手机号' }]"
      >
        <template #button>
          <button class="sms-button" type="button"
            :disabled="!validMobile(mobile) || sending || submitting || seconds > 0"
            @click="sendSms">
            {{ seconds > 0 ? `${seconds}s后重新获取` : (sending ? '发送中...' : '获取验证码') }}
          </button>
        </template>
      </van-field>
      <van-field
        v-model.trim="captcha" type="digit" name="captcha" placeholder="验证码"
        autocomplete="one-time-code" maxlength="6" :disabled="submitting"
        :rules="[{ required: true, message: '请输入短信验证码' }]"
      />
        <van-button class="login-button" block color="#43d568" native-type="submit"
          :loading="submitting" :disabled="sending" loading-text="登录中...">
          登录
        </van-button>
      </van-form>
    </section>
  </main>
</template>

<script>
import {
  Form, Field, Button, NavBar, Toast, Dialog,
} from 'vant';
import api from '@/apis/promoter';
import {
  NON_PROMOTER_MESSAGE, isNonPromoter, savePromoterSession,
} from '@/utils/promoter';

export default {
  components: {
    [Form.name]: Form,
    [Field.name]: Field,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
  },
  data() {
    return {
      mobile: '',
      captcha: '',
      sending: false,
      submitting: false,
      seconds: 0,
      timer: null,
    };
  },
  beforeDestroy() { clearInterval(this.timer); },
  methods: {
    validMobile(value) { return /^1[3-9]\d{9}$/.test(value); },
    async handleFailure(result) {
      if (isNonPromoter(result)) {
        await Dialog.alert({ message: NON_PROMOTER_MESSAGE });
      } else {
        Toast(result.msg || '操作失败，请稍后重试');
      }
    },
    async sendSms() {
      if (this.sending || this.submitting || this.seconds) return;
      if (!this.validMobile(this.mobile)) { Toast('请输入正确的11位手机号'); return; }
      this.sending = true;
      try {
        const result = await api.sendSms({ mobile: this.mobile });
        if (Number(result.code) !== 0 || result.success === false) {
          await this.handleFailure(result);
          return;
        }
        Toast('验证码已发送');
        const end = Date.now() + 60000;
        this.seconds = 60;
        this.timer = setInterval(() => {
          this.seconds = Math.max(0, Math.ceil((end - Date.now()) / 1000));
          if (!this.seconds) clearInterval(this.timer);
        }, 1000);
      } catch (error) {
        Toast('验证码发送失败，请检查网络后重试');
      } finally {
        this.sending = false;
      }
    },
    async onSubmit() {
      if (this.submitting || this.sending) return;
      if (!this.validMobile(this.mobile) || !this.captcha) return;
      this.submitting = true;
      try {
        const result = await api.login({ mobile: this.mobile, captcha: this.captcha });
        if (Number(result.code) !== 0 || result.success === false) {
          await this.handleFailure(result);
          return;
        }
        const token = result.data && result.data.token;
        if (typeof token !== 'string' || !token.trim()) {
          Toast('登录凭证为空，请联系服务商');
          return;
        }
        savePromoterSession(this.mobile, token);
        this.$router.replace('/web/promoter/orders');
      } catch (error) {
        Toast('登录失败，请检查网络后重试');
      } finally {
        this.submitting = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.promoter-login {
  min-height: 100vh;
  background: #fff;
  color: #333;
  .login-content { padding: 32px 38px; }
  ::v-deep .van-nav-bar--fixed { z-index: 1001; }
  h1 { font-size: 30px; font-weight: 400; }
  h2 { margin: 80px 0 18px; font-size: 21px; font-weight: 400; }
  .van-field {
    margin-bottom: 16px;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    padding: 13px 10px;
  }
  .van-field::after { display: none; }
  .sms-button { border: 0; background: transparent; color: #43bd65; font-size: 14px; }
  .sms-button:disabled { color: #ccc; }
  .login-button { margin-top: 82px; border-radius: 4px; font-size: 18px; }
}
</style>
